import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    salaryRequestFrom: Yup.number()
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
    salaryRequestTo: Yup.number()
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label>Frühestmöglicher Eintritt</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Frühestmöglichen Eintrittstermin eingeben"
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formSalaryRequestFrom">
                <Form.Label>Gehaltswunsch /Jahr (brutto) Von*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gehaltswunsch /Jahr (brutto) Von"
                    type="text"
                    name="salaryRequestFrom"
                    value={values.salaryRequestFrom || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequestFrom && !errors.salaryRequestFrom}
                    isInvalid={touched.salaryRequestFrom && errors.salaryRequestFrom}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequestFrom}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formSalaryRequestTo">
                <Form.Label>Gehaltswunsch /Jahr (brutto) Bis*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gehaltswunsch /Jahr (brutto) Bis"
                    type="text"
                    name="salaryRequestTo"
                    value={values.salaryRequestTo || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequestTo && !errors.salaryRequestTo}
                    isInvalid={touched.salaryRequestTo && errors.salaryRequestTo}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequestTo}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};